// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"776":"02c0eb69","975":"adac68f2"}[chunkId] + ".chunk.js";
};